import SiteConstants, {
  VIDEOBLOCKS,
} from '../../../../common/SiteConstants/SiteConstants';
import { getCurrentSite } from '../../../../common/utils';
import LayoutBlocksSearchResults from './LayoutBlocksSearchResults';
import SimpleSearchResults from './SimpleSearchResults';
import VideoSearchResults from './VideoSearchResults';

function factory() {
  if (getCurrentSite() === VIDEOBLOCKS) {
    return VideoSearchResults;
  }
  // TODO: break out graphic and audio search results into dedicated components
  return SiteConstants.getInstance().shouldUseLayoutBlocks()
    ? LayoutBlocksSearchResults
    : SimpleSearchResults;
}

const SearchResults = factory();

export default SearchResults;
